import { useState, useEffect } from 'react'
import PubSub from 'pubsub-js'
import { Button, Form, FormGroup, Label, Input, Row, Col } from 'reactstrap'
import CustomSelectList from '../CustomCode/CustomSelectList'
import './ActivityLog.css'

export default function ActivityLogForm(props) {
  const { objectTypeId, actionUserId, fromDate, toDate, setRoute } = props
  console.log('ActivityLogForm rendered: ', props)

  useEffect(() => {
    function handleUserClickedEvent(msg, data) {
      console.log(`EVENT RECEIVED (ActivityForm): ${msg}`, data)
      setRoute({ ...inputs, 'actionUserId': data })
    }
    function handleEntityClickedEvent(msg, data) {
      console.log(`EVENT RECEIVED (ActivityForm): ${msg}`, data)
      setRoute({ ...inputs, 'objectTypeId': data })
    }
    const userToken = PubSub.subscribe('ACTIVITY LOG USER CLICKED', handleUserClickedEvent)
    const eventToken = PubSub.subscribe('ACTIVITY LOG ENTITY CLICKED', handleEntityClickedEvent)
    return function cleanup() {
      PubSub.unsubscribe(userToken)
      PubSub.unsubscribe(eventToken)
    }
  })

  let date = new Date()
  let prevDate = new Date()
  prevDate.setMonth(-1)

  const initialValues = {
    objectTypeId: objectTypeId ? objectTypeId : '',
    actionUserId: actionUserId ? actionUserId : '',
    fromDate: fromDate ? fromDate : prevDate.toISOString().substring(0,10),
    toDate: toDate ? toDate : date.toISOString().substring(0,10),
  }
  const [inputs, setInputs] = useState(initialValues)
  console.log(inputs)

  function resetButtonClicked(e) {
    e.preventDefault()
    setInputs({ objectTypeId: '', actionUserId: '', fromDate: prevDate.toISOString().substring(0,10), toDate: date.toISOString().substring(0,10) })
  }

  function goButtonClicked(e) {
    e.preventDefault()
    setRoute(inputs)
  }

  function handleChange(e) {
    console.log(e)
    setInputs({ ...inputs, [e.target.name]: e.target.value })
  }

  return (
    <div style={{ display: 'inline-block', padding: '5px'}}>
      <Form>
        <Row>
          <Col>
            <FormGroup>
              <Label for="event" style={{ float: 'left', marginLeft: '5px', fontWeight: 'bold' }}>Entity Types</Label>
              <CustomSelectList name="objectTypeId" handleChange={handleChange} modelName="Admin" entityName="activity_log_entities" controlledInput={true} defaultValue={inputs.objectTypeId} />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label for="user" style={{ float: 'left', marginLeft: '10px', fontWeight: 'bold' }}>Users</Label>
              <CustomSelectList name="actionUserId"  handleChange={handleChange} modelName="Admin" entityName="activity_log_users" controlledInput={true} defaultValue={inputs.actionUserId} />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label for="from-date" style={{ float: 'left', fontWeight: 'bold' }}>From</Label>
              <Input type="date" name="fromDate" id="from-date" value={inputs.fromDate} onChange={handleChange} />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label for="to-date" style={{ float: 'left', fontWeight: 'bold' }}>To</Label>
              <Input type="date" name="toDate" id="to-date" value={inputs.toDate} onChange={handleChange} />
            </FormGroup>
          </Col>
          <Col style={{ marginTop: '27px' }}>
            <Button color="primary" onClick={(e) => goButtonClicked(e)}>Go</Button>
            <Button color="secondary" style={{ marginLeft: '10px' }} onClick={(e) => resetButtonClicked(e)}>Reset</Button>
          </Col>
        </Row>
      </Form>
    </div>
  )
}
